import { ComplaintItem } from 'components/template/casino/casino-complaints';
import { IComplaint, IQuestion } from 'constants/types';
import _ from 'lodash';
import styles from './comment-section.module.css';

type TopicListVariant = 'question' | 'complaint';

interface CommentSectionProps {
  variant: TopicListVariant;
  items: Array<IQuestion | IComplaint>;
  showMoreButton?: React.JSX.Element;
}

export const countChildren = (
  questions: IQuestion[],
  currentQuestion: IQuestion
): number => {
  const groupedByParent = _.groupBy(questions, 'parent');
  const children = groupedByParent[currentQuestion._id] || [];

  return children.length;
};

export const TopicCommentSection = ({
  variant,
  items,
  showMoreButton,
}: CommentSectionProps) => {
  return (
    <div className={styles.commentContainer}>
      <div className={styles.commentList}>
        {items.map((item, index) => (
          <ComplaintItem
            item={item}
            key={item._id}
            category={
              variant === 'question'
                ? (item as IQuestion).category?.length
                  ? (item as IQuestion).category
                  : 'Other'
                : undefined
            }
            isLast={index === items.length - 1}
            routeTo={variant === 'question' ? 'question' : 'complaint'}
            rounded
          />
        ))}
      </div>
      {showMoreButton}
    </div>
  );
};
